import { render } from "./callout-product-card.vue?vue&type=template&id=9b34a13a"
import script from "./callout-product-card.vue?vue&type=script&lang=js"
export * from "./callout-product-card.vue?vue&type=script&lang=js"

import "./callout-product-card.vue?vue&type=style&index=0&id=9b34a13a&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__